import { type FunctionComponent } from 'react'

import { t } from 'i18next'

import { ReactComponent as OrchestrationSvg } from 'assets/OrchestrationJob.svg'
import { ReactComponent as TransformationSvg } from 'assets/TransformationJob.svg'

import { JobType } from 'job-lib/types/JobType'

export interface JobTypeIconProps {
  jobType: JobType
}

export const JobTypeIcon: FunctionComponent<JobTypeIconProps> = ({ jobType }) =>
  jobType === JobType.Orchestration ? (
    <OrchestrationSvg
      title={t('canvas.orchestrationJob')}
      data-testid="orchestration-job-icon"
    />
  ) : (
    <TransformationSvg
      title={t('canvas.transformationJob')}
      data-testid="transformation-job-icon"
    />
  )
